import { RiskLevel } from "@/model/RiskLevel";
import Logo from "@/assets/regions/devon-logo.png";
import { NullBanner } from "@/model/DefaultBanners";
const DevonLower = {
    rawCopy: "Keep up the good work."
};
const DevonIncreasing = {
    rawCopy: `For Increasing Risk scores we recommend that you cut down your drinking. <u>Click here to book a free online appointment</u> with a DrinkCoach.`,
    logoLink: "https://bookdrinkcoach.as.me/devon"
};
const DevonHigher = {
    rawCopy: `For Higher Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with a DrinkCoach.`,
    logoLink: "https://bookdrinkcoach.as.me/devon"
};
const DevonHigh = {
    rawCopy: `For alcohol advice and support in Devon call Together on 0800 233 5444 or email <u>SW_together@waythrough.org.uk</u>`,
    logoLink: "mailto:SW_together@waythrough.org.uk"
};
export default {
    name: "Devon",
    zoomLevel: 10,
    logo: {
        file: Logo,
        width: 470,
        height: 215
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DevonLower,
        [RiskLevel.Increasing]: DevonIncreasing,
        [RiskLevel.Higher]: DevonHigher,
        [RiskLevel.High]: DevonHigh
    },
    regions: [
        "East Devon",
        "Exeter",
        "Mid Devon",
        "North Devon",
        "South Hams",
        "Teignbridge",
        "Torridge",
        "West Devon"
    ],
    clinics: [
        {
            name: "Together",
            other_info: "Together has several hubs - use the 'Find Support Near You' tool to find your closest one:",
            description: "Contact Together on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            phone: ["0800 233 5444"],
            isPrimaryProvider: true,
            linkToSupportFinderInAddress: true,
            email: "SW_together@waythrough.org.uk",
            website: "https://www.waythrough.org.uk/find-support-near-me/together/"
        },
        {
            name: "Together: Exeter",
            description: "Contact ${name} on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            location: { lat: 50.7232868, lng: -3.5161952 },
            phone: ["0800 233 5444"],
            address: "Magdalene House, Grendon Road, Exeter, EX1 2NJ",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 2000 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "SW_together@waythrough.org.uk",
            website: "https://www.waythrough.org.uk/find-support-near-me/together/"
        },
        {
            name: "Together: Newton Abbot",
            description: "Contact ${name} on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            location: { lat: 50.5287437, lng: -3.6097672 },
            phone: ["0800 233 5444"],
            address: "Unit 2, Templar House, Scott Close, Newton Abbot, TQ12 1GJ",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1900 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "SW_together@waythrough.org.uk",
            website: "https://www.waythrough.org.uk/find-support-near-me/together/"
        },
        {
            name: "Together: Barnstaple",
            description: "Contact ${name} on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            location: { lat: 51.0795506, lng: -4.0649741 },
            phone: ["0800 233 5444"],
            address: "Riverside Court, Castle Street, Barnstaple, EX31 1DR",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    },
                    info: "<br>Late night opening by request on Wednesdays."
                }
            ],
            email: "SW_together@waythrough.org.uk",
            website: "https://www.waythrough.org.uk/find-support-near-me/together/"
        }
    ]
};
//# sourceMappingURL=Devon.js.map